import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printReceiptVerification } from './printReceiptVerification';

export default {
    name: 'ReceiptVerification',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewReceiptVerificationsUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.isFacilityUser) {
            this.loadEligibleOrders();
        }
        if (this.$route && this.$route.query && this.$route.query.id) {
            this.openDetail({ id: Number(this.$route.query.id) });
        }
    },

    computed: {
        isMinistryAdmin() {
            return this.isMinistryStockAdminUi();
        },
        isFacilityUser() {
            return this.canVerifyReceiptsUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي المحاضر', this.pages, 'primary', 'ti ti-clipboard-check'),
                this.statCard('قيد التحقق', this.countWhere(this.Info, item => this.matchStatus(item, [1], ['قيد التحقق'])), 'warning', 'ti ti-progress'),
                this.statCard('محاضر مكتملة', this.countWhere(this.Info, item => this.matchStatus(item, [2], ['مكتمل'])), 'success', 'ti ti-circle-check'),
                this.statCard('إجمالي المستلم الحالي', this.sumWhere(this.Info, item => item.totalReceivedQty), 'info', 'ti ti-package'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            finalizeDialog: false,
            finalizeLines: [],
            createDialog: false,
            selectedOrderId: null,
            eligibleOrders: [],
            eligibleSearch: '',
        };
    },

    methods: {
        statusBadgeClass(status) {
            const normalizedStatus = Number(status);
            if (normalizedStatus === 2) return 'bg-label-success';
            if (normalizedStatus === 1) return 'bg-label-warning';
            return 'bg-label-secondary';
        },
        statusLabel(s) {
            if (s === 1) return 'قيد التحقق';
            if (s === 2) return 'مكتمل';
            return '-';
        },
        decisionBadgeClass(d) {
            if (d === 1) return 'bg-label-success';
            if (d === 2) return 'bg-label-warning';
            if (d === 3) return 'bg-label-danger';
            if (d === 4) return 'bg-label-info';
            if (d === 5) return 'bg-label-secondary';
            return 'bg-label-secondary';
        },
        verificationCode(item) {
            if (!item) return '-';
            return item.orderCode || item.code || `RV-${item.id}`;
        },
        verificationMetaText(item) {
            if (!item) return '-';
            const expected = Number(item.totalExpectedQty || 0);
            const received = Number(item.totalReceivedQty || 0);
            return `المتوقع ${expected} وحدة | المستلم ${received} وحدة`;
        },
        decisionLabel(d) {
            if (d === 1) return 'قبول';
            if (d === 2) return 'تعديل كمية';
            if (d === 3) return 'رفض صنف';
            if (d === 4) return 'تبليغ نقص/تالف';
            if (d === 5) return 'استرجاع';
            return '-';
        },
        detailTotalExpected(detail) {
            if (!detail) return 0;
            if (detail.totalExpectedQty != null) return Number(detail.totalExpectedQty || 0);
            return (detail.lines || []).reduce((sum, line) => sum + Number(line.expectedQty || 0), 0);
        },
        detailTotalReceived(detail) {
            if (!detail) return 0;
            if (detail.totalReceivedQty != null) return Number(detail.totalReceivedQty || 0);
            return (detail.lines || []).reduce((sum, line) => sum + Number(line.receivedQty || 0), 0);
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetReceiptVerifications(this.pageNo, this.pageSize, this.Search, this.statusFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        loadEligibleOrders() {
            this.$http.GetEligibleReceiptVerificationOrders(this.eligibleSearch)
                .then((response) => {
                    this.eligibleOrders = response.data.info || [];
                })
                .catch(() => {
                    this.eligibleOrders = [];
                });
        },
        openCreateDialog() {
            this.selectedOrderId = null;
            this.eligibleSearch = '';
            this.loadEligibleOrders();
            this.createDialog = true;
        },
        createFromOrder(orderId) {
            const oid = Number(orderId || this.selectedOrderId);
            if (!oid) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر طلباً مصروفاً أولاً.');
                return;
            }
            this.$blockUI.Start();
            this.$http.CreateReceiptVerificationFromOrder(oid)
                .then((response) => {
                    this.$blockUI.Stop();
                    const data = response.data || {};
                    this.$helper.ShowMessage('success', 'تم', data.message || 'تم فتح المحضر.');
                    this.createDialog = false;
                    this.GetInfo(1);
                    if (data.id) {
                        this.openDetail({ id: data.id });
                    }
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openDetail(item) {
            const id = item && item.id ? item.id : null;
            if (!id) return;
            this.$blockUI.Start();
            this.$http.GetReceiptVerification(id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openFinalize() {
            if (!this.detail || !this.detail.lines) return;
            this.finalizeLines = this.detail.lines.map((line) => ({
                lineId: line.id,
                productName: line.productName,
                expectedQty: line.expectedQty,
                receivedQty: line.receivedQty,
                decision: line.decision,
                note: line.note || '',
            }));
            this.finalizeDialog = true;
        },
        clampReceivedQty(line) {
            let q = Number(line.receivedQty);
            if (isNaN(q) || q < 0) q = 0;
            if (q > Number(line.expectedQty)) q = Number(line.expectedQty);
            line.receivedQty = q;
        },
        submitFinalize() {
            const body = {
                id: this.detail.id,
                lines: this.finalizeLines.map((line) => ({
                    lineId: line.lineId,
                    receivedQty: Number(line.receivedQty),
                    decision: Number(line.decision),
                    note: line.note || null,
                }))
            };
            this.$blockUI.Start();
            this.$http.FinalizeReceiptVerification(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.finalizeDialog = false;
                    this.openDetail({ id: this.detail.id });
                    this.GetInfo(this.pageNo);
                    this.loadEligibleOrders();
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        printDetail() {
            if (!this.detail || !this.detail.canPrint) return;
            this.$http.MarkReceiptVerificationPrinted(this.detail.id)
                .then(() => {
                    const opened = printReceiptVerification(this.detail);
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة.');
                        return;
                    }
                    this.openDetail({ id: this.detail.id });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
